let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hhCVh")).then(() => parcelRequire('eJrv9'));